export const US_STATES = [
	{ title: 'Alaska', value: 'AK' },
	{ title: 'Alabama', value: 'AL' },
	{ title: 'Arkansas', value: 'AR' },
	{ title: 'American Samoa', value: 'AS' },
	{ title: 'Arizona', value: 'AZ' },
	{ title: 'California', value: 'CA' },
	{ title: 'Colorado', value: 'CO' },
	{ title: 'Connecticut', value: 'CT' },
	{ title: 'District of Columbia', value: 'DC' },
	{ title: 'Delaware', value: 'DE' },
	{ title: 'Florida', value: 'FL' },
	{ title: 'Georgia', value: 'GA' },
	{ title: 'Guam', value: 'GU' },
	{ title: 'Hawaii', value: 'HI' },
	{ title: 'Iowa', value: 'IA' },
	{ title: 'Idaho', value: 'ID' },
	{ title: 'Illinois', value: 'IL' },
	{ title: 'Indiana', value: 'IN' },
	{ title: 'Kansas', value: 'KS' },
	{ title: 'Kentucky', value: 'KY' },
	{ title: 'Louisiana', value: 'LA' },
	{ title: 'Massachusetts', value: 'MA' },
	{ title: 'Maryland', value: 'MD' },
	{ title: 'Maine', value: 'ME' },
	{ title: 'Michigan', value: 'MI' },
	{ title: 'Minnesota', value: 'MN' },
	{ title: 'Missouri', value: 'MO' },
	{ title: 'Mississippi', value: 'MS' },
	{ title: 'Montana', value: 'MT' },
	{ title: 'North Carolina', value: 'NC' },
	{ title: 'North Dakota', value: 'ND' },
	{ title: 'Nebraska', value: 'NE' },
	{ title: 'New Hampshire', value: 'NH' },
	{ title: 'New Jersey', value: 'NJ' },
	{ title: 'New Mexico', value: 'NM' },
	{ title: 'Nevada', value: 'NV' },
	{ title: 'New York', value: 'NY' },
	{ title: 'Ohio', value: 'OH' },
	{ title: 'Oklahoma', value: 'OK' },
	{ title: 'Oregon', value: 'OR' },
	{ title: 'Pennsylvania', value: 'PA' },
	{ title: 'Puerto Rico', value: 'PR' },
	{ title: 'Rhode Island', value: 'RI' },
	{ title: 'South Carolina', value: 'SC' },
	{ title: 'South Dakota', value: 'SD' },
	{ title: 'Tennessee', value: 'TN' },
	{ title: 'Texas', value: 'TX' },
	{ title: 'Utah', value: 'UT' },
	{ title: 'Virginia', value: 'VA' },
	{ title: 'Virgin Islands', value: 'VI' },
	{ title: 'Vermont', value: 'VT' },
	{ title: 'Washington', value: 'WA' },
	{ title: 'Wisconsin', value: 'WI' },
	{ title: 'West Virginia', value: 'WV' },
	{ title: 'Wyoming', value: 'WY' }
];

export const TimePickerObjects = [
	{ value: '00:00:00', name: 'Midnight', style: 'lightBlue', disabled: false },
	{ value: '00:15:00', name: '12:15', style: 'lightBlue', disabled: false },
	{ value: '00:30:00', name: '12:30', style: 'lightBlue', disabled: false },
	{ value: '00:45:00', name: '12:45', style: 'lightBlue', disabled: false },
	{ value: '01:00:00', name: '01:00', style: 'lightBlue', disabled: false },
	{ value: '01:15:00', name: '01:15', style: 'lightBlue', disabled: false },
	{ value: '01:30:00', name: '01:30', style: 'lightBlue', disabled: false },
	{ value: '01:45:00', name: '01:45', style: 'lightBlue', disabled: false },
	{ value: '02:00:00', name: '02:00', style: 'lightBlue', disabled: false },
	{ value: '02:15:00', name: '02:15', style: 'lightBlue', disabled: false },
	{ value: '02:30:00', name: '02:30', style: 'lightBlue', disabled: false },
	{ value: '02:45:00', name: '02:45', style: 'lightBlue', disabled: false },
	{ value: '03:00:00', name: '03:00', style: 'lightBlue', disabled: false },
	{ value: '03:15:00', name: '03:15', style: 'lightBlue', disabled: false },
	{ value: '03:30:00', name: '03:30', style: 'lightBlue', disabled: false },
	{ value: '03:45:00', name: '03:45', style: 'lightBlue', disabled: false },
	{ value: '04:00:00', name: '04:00', style: 'lightBlue', disabled: false },
	{ value: '04:15:00', name: '04:15', style: 'lightBlue', disabled: false },
	{ value: '04:30:00', name: '04:30', style: 'lightBlue', disabled: false },
	{ value: '04:45:00', name: '04:45', style: 'lightBlue', disabled: false },
	{ value: '05:00:00', name: '05:00', style: 'lightBlue', disabled: false },
	{ value: '05:15:00', name: '05:15', style: 'lightBlue', disabled: false },
	{ value: '05:30:00', name: '05:30', style: 'lightBlue', disabled: false },
	{ value: '05:45:00', name: '05:45', style: 'lightBlue', disabled: false },
	{ value: '06:00:00', name: '06:00', style: 'lightBlue', disabled: false },
	{ value: '06:15:00', name: '06:15', style: 'lightBlue', disabled: false },
	{ value: '06:30:00', name: '06:30', style: 'lightBlue', disabled: false },
	{ value: '06:45:00', name: '06:45', style: 'lightBlue', disabled: false },
	{ value: '07:00:00', name: '07:00', style: 'darkBlue', disabled: false },
	{ value: '07:15:00', name: '07:15', style: 'darkBlue', disabled: false },
	{ value: '07:30:00', name: '07:30', style: 'darkBlue', disabled: false },
	{ value: '07:45:00', name: '07:45', style: 'darkBlue', disabled: false },
	{ value: '08:00:00', name: '08:00', style: 'darkBlue', disabled: false },
	{ value: '08:15:00', name: '08:15', style: 'darkBlue', disabled: false },
	{ value: '08:30:00', name: '08:30', style: 'darkBlue', disabled: false },
	{ value: '08:45:00', name: '08:45', style: 'darkBlue', disabled: false },
	{ value: '09:00:00', name: '09:00', style: 'darkBlue', disabled: false },
	{ value: '09:15:00', name: '09:15', style: 'darkBlue', disabled: false },
	{ value: '09:30:00', name: '09:30', style: 'darkBlue', disabled: false },
	{ value: '09:45:00', name: '09:45', style: 'darkBlue', disabled: false },
	{ value: '10:00:00', name: '10:00', style: 'darkBlue', disabled: false },
	{ value: '10:15:00', name: '10:15', style: 'darkBlue', disabled: false },
	{ value: '10:30:00', name: '10:30', style: 'darkBlue', disabled: false },
	{ value: '10:45:00', name: '10:45', style: 'darkBlue', disabled: false },
	{ value: '11:00:00', name: '11:00', style: 'darkBlue', disabled: false },
	{ value: '11:15:00', name: '11:15', style: 'darkBlue', disabled: false },
	{ value: '11:30:00', name: '11:30', style: 'darkBlue', disabled: false },
	{ value: '11:45:00', name: '11:45', style: 'darkBlue', disabled: false },
	{ value: '12:00:00', name: 'Noon', style: 'darkGreen', disabled: false },
	{ value: '12:15:00', name: '12:15 PM', style: 'darkGreen', disabled: false },
	{ value: '12:30:00', name: '12:30 PM', style: 'darkGreen', disabled: false },
	{ value: '12:45:00', name: '12:45 PM', style: 'darkGreen', disabled: false },
	{ value: '13:00:00', name: '01:00 PM', style: 'darkGreen', disabled: false },
	{ value: '13:15:00', name: '01:15 PM', style: 'darkGreen', disabled: false },
	{ value: '13:30:00', name: '01:30 PM', style: 'darkGreen', disabled: false },
	{ value: '13:45:00', name: '01:45 PM', style: 'darkGreen', disabled: false },
	{ value: '14:00:00', name: '02:00 PM', style: 'darkGreen', disabled: false },
	{ value: '14:15:00', name: '02:15 PM', style: 'darkGreen', disabled: false },
	{ value: '14:30:00', name: '02:30 PM', style: 'darkGreen', disabled: false },
	{ value: '14:45:00', name: '02:45 PM', style: 'darkGreen', disabled: false },
	{ value: '15:00:00', name: '03:00 PM', style: 'darkGreen', disabled: false },
	{ value: '15:15:00', name: '03:15 PM', style: 'darkGreen', disabled: false },
	{ value: '15:30:00', name: '03:30 PM', style: 'darkGreen', disabled: false },
	{ value: '15:45:00', name: '03:45 PM', style: 'darkGreen', disabled: false },
	{ value: '16:00:00', name: '04:00 PM', style: 'darkGreen', disabled: false },
	{ value: '16:15:00', name: '04:15 PM', style: 'darkGreen', disabled: false },
	{ value: '16:30:00', name: '04:30 PM', style: 'darkGreen', disabled: false },
	{ value: '16:45:00', name: '04:45 PM', style: 'darkGreen', disabled: false },
	{ value: '17:00:00', name: '05:00 PM', style: 'darkGreen', disabled: false },
	{ value: '17:15:00', name: '05:15 PM', style: 'darkGreen', disabled: false },
	{ value: '17:30:00', name: '05:30 PM', style: 'darkGreen', disabled: false },
	{ value: '17:45:00', name: '05:45 PM', style: 'darkGreen', disabled: false },
	{ value: '18:00:00', name: '06:00 PM', style: 'lightGreen', disabled: false },
	{ value: '18:15:00', name: '06:15 PM', style: 'lightGreen', disabled: false },
	{ value: '18:30:00', name: '06:30 PM', style: 'lightGreen', disabled: false },
	{ value: '18:45:00', name: '06:45 PM', style: 'lightGreen', disabled: false },
	{ value: '19:00:00', name: '07:00 PM', style: 'lightGreen', disabled: false },
	{ value: '19:15:00', name: '07:15 PM', style: 'lightGreen', disabled: false },
	{ value: '19:30:00', name: '07:30 PM', style: 'lightGreen', disabled: false },
	{ value: '19:45:00', name: '07:45 PM', style: 'lightGreen', disabled: false },
	{ value: '20:00:00', name: '08:00 PM', style: 'lightGreen', disabled: false },
	{ value: '20:15:00', name: '08:15 PM', style: 'lightGreen', disabled: false },
	{ value: '20:30:00', name: '08:30 PM', style: 'lightGreen', disabled: false },
	{ value: '20:45:00', name: '08:45 PM', style: 'lightGreen', disabled: false },
	{ value: '21:00:00', name: '09:00 PM', style: 'lightGreen', disabled: false },
	{ value: '21:15:00', name: '09:15 PM', style: 'lightGreen', disabled: false },
	{ value: '21:30:00', name: '09:30 PM', style: 'lightGreen', disabled: false },
	{ value: '21:45:00', name: '09:45 PM', style: 'lightGreen', disabled: false },
	{ value: '22:00:00', name: '10:00 PM', style: 'lightGreen', disabled: false },
	{ value: '22:15:00', name: '10:15 PM', style: 'lightGreen', disabled: false },
	{ value: '22:30:00', name: '10:30 PM', style: 'lightGreen', disabled: false },
	{ value: '22:45:00', name: '10:45 PM', style: 'lightGreen', disabled: false },
	{ value: '23:00:00', name: '11:00 PM', style: 'lightGreen', disabled: false },
	{ value: '23:15:00', name: '11:15 PM', style: 'lightGreen', disabled: false },
	{ value: '23:30:00', name: '11:30 PM', style: 'lightGreen', disabled: false },
	{ value: '23:45:00', name: '11:45 PM', style: 'lightGreen', disabled: false }
];
